<div class="branding-view">


  <mat-card class="main-card">
    <mat-tab-group dynamicHeight mat-stretch-tabs class="branding-tab-group"
      (selectedTabChange)="onTabChange($event.selectedIndex)">

      <!-- Company Details Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label">
            <mat-icon class="tab-icon">business</mat-icon>
            <span>Company Details</span>
          </div>
        </ng-template>

        <div class="tab-content">
          <div class="content-header">
            <h2>Company Branding</h2>
            <p>Upload your company logo and complete company information to personalize the candidate experience</p>
          </div>

          <div class="branding-container">
            <!-- Logo Upload Card -->
            <div class="logo-card">
              <div class="card-header">
                <div class="header-icon">
                  <mat-icon>image</mat-icon>
                </div>
                <div class="header-content">
                  <h3>Company Logo</h3>
                  <p>Upload your logo to personalize candidate experience</p>
                </div>
              </div>

              <div class="logo-upload-area" (click)="triggerLogoUpload()">
                <div class="upload-zone" [class.has-logo]="logo">
                  <div *ngIf="!logo" class="upload-placeholder">
                    <div class="upload-icon">
                      <mat-icon>cloud_upload</mat-icon>
                    </div>
                    <h4>Upload Your Logo</h4>
                    <p>Drag & drop or click to upload</p>
                    <span class="upload-hint">PNG, JPG up to 5MB • Min 200x200px</span>
                  </div>

                  <div *ngIf="logo" class="logo-preview">
                    <img [src]="logo" alt="Company Logo" class="preview-image">
                    <div class="preview-overlay">
                      <mat-icon>edit</mat-icon>
                      <span>Change Logo</span>
                    </div>
                  </div>
                </div>
                <input #fileInput type="file" accept="image/*" (change)="onLogoFileSelected($event)"
                  style="display: none;">
              </div>
            </div>

            <!-- Company Details Card -->
            <div class="details-card">
              <div class="card-header">
                <div class="header-icon">
                  <mat-icon>business</mat-icon>
                </div>
                <div class="header-content">
                  <h3>Company Information</h3>
                  <p>Complete your company profile details</p>
                </div>
              </div>

              <form class="company-form" [formGroup]="companyDetailsForm">
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Company Name</mat-label>
                    <input matInput placeholder="Enter your company name" formControlName="companyName" required>
                    <mat-icon matSuffix>domain</mat-icon>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('required')">
                      Company name is required
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('minlengthStrict')">
                      Company name must be at least 2 characters
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('digitsOnly')">
                      Company name cannot be only numbers
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('alphaRequired')">
                      Company name must include alphabetic characters
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('multiSpace')">
                      Company name cannot contain multiple consecutive spaces
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('invalidChars')">
                      Only letters, numbers and . , & - ' ( ) are allowed
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('companyName')?.hasError('whitespace')">
                      Company name cannot be empty or only spaces
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="form-row">
                  <div class="phone-field-container">
                    <label class="phone-field-label">Phone Number</label>
                    <ngx-intl-tel-input [cssClass]="'phone-input-field'" [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                      [phoneValidation]="true" [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.International" name="phone" formControlName="phone">
                    </ngx-intl-tel-input>
                    <mat-icon class="phone-field-icon">phone</mat-icon>
                  </div>
                  <div class="phone-validation" *ngIf="companyDetailsForm.controls['phone'].invalid">
                    <mat-icon>error</mat-icon>
                    <span>Please enter a valid phone number</span>
                  </div>
                </div>

                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Company Address</mat-label>
                    <textarea matInput rows="3" placeholder="Enter your company address" formControlName="address"
                      required></textarea>
                    <mat-icon matSuffix>location_on</mat-icon>
                    <mat-error *ngIf="companyDetailsForm.get('address')?.hasError('required')">
                      Company address is required
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('address')?.hasError('whitespace')">
                      Company address cannot be empty or only spaces
                    </mat-error>
                    <mat-error
                      *ngIf="companyDetailsForm.get('address')?.hasError('minlength') || companyDetailsForm.get('address')?.hasError('minlengthStrict')">
                      Company address must be at least 5 characters
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('address')?.hasError('multiSpace')">
                      Company address cannot contain multiple consecutive spaces
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('address')?.hasError('alnumRequired')">
                      Company address must include letters or numbers
                    </mat-error>
                    <mat-error *ngIf="companyDetailsForm.get('address')?.hasError('invalidChars')">
                      Only letters, numbers and . , # & - ' ( ) / : are allowed
                    </mat-error>
                  </mat-form-field>
                </div>
              </form>
            </div>
          </div>

          <div class="action-bar">
            <button mat-stroked-button color="primary" class="save-btn"
              [disabled]="!companyDetailsForm.valid || companyDetailsForm.pristine" (click)="updateCompanyProfile()">
              <mat-icon>save</mat-icon>
              Save Changes
            </button>
          </div>
        </div>
      </mat-tab>

      <!-- Email Templates Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label">
            <mat-icon class="tab-icon">email</mat-icon>
            <span>Email Templates</span>
            <span class="tab-badge"
              *ngIf="getTemplateCount('EMAIL_TEMPLATE') > 0">{{getTemplateCount('EMAIL_TEMPLATE')}}</span>
          </div>
        </ng-template>

        <div class="tab-content">
          <div class="content-header">
            <h2>Email Templates</h2>
            <p>Create and manage email templates for candidate communications</p>
          </div>

          <div class="templates-container">
            <div class="templates-header">
              <button mat-stroked-button color="primary" class="create-btn" (click)="addEmailTemplate()">
                <mat-icon>add</mat-icon>
                Create Email Template
              </button>
            </div>

            <div class="templates-content">
              <div class="templates-grid" *ngIf="emailTemplates?.length > 0">
                <div class="template-card"
                  *ngFor="let item of emailTemplates; let i = index; trackBy: trackByTemplateId">
                  <div class="template-header">
                    <div class="template-info">
                      <h4 [innerHTML]="item?.templateName | replaceAll : headerPlaceholderDummies"></h4>
                      <span class="template-type">Email Template</span>
                    </div>
                    <div class="template-actions">
                      <button class="action-btn expand-btn" mat-icon-button (click)="expandEmailTemplate(i)">
                        <mat-icon>{{selectedEmailTemplateIndex === i ? 'expand_less' : 'expand_more'}}</mat-icon>
                      </button>
                      <ng-container *ngIf="!item.isDefault">
                        <button class="action-btn edit-btn" mat-icon-button
                          (click)="editTemplate(item, 'Email Template')">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button class="action-btn delete-btn" mat-icon-button
                          (click)="deleteTemplate(item, 'email template')">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                  <div class="template-preview" *ngIf="selectedEmailTemplateIndex === i">
                    <app-template-details [templateDetails]="item" [templateType]="'email'" [logo]="logo"
                      [mobileNumber]="companyDetailsForm.get('phone')?.value?.number" [cardHeading]="emailCardHeading"
                      [assessmentData]="null" [companyName]="companyDetailsForm.get('companyName')?.value"
                      [profile]="companyDetailsForm?.value">
                    </app-template-details>
                  </div>
                </div>
              </div>

              <div class="empty-state" *ngIf="emailTemplates?.length == 0">
                <div class="empty-icon">
                  <mat-icon>email_outline</mat-icon>
                </div>
                <h3>No Email Templates yet</h3>
                <p>Get started by creating your first email template for candidates.</p>
                <button mat-stroked-button color="primary" (click)="addEmailTemplate()">
                  <mat-icon>add</mat-icon>
                  Create Email Template
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Welcome Templates Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label">
            <mat-icon class="tab-icon">waving_hand</mat-icon>
            <span>Welcome Templates</span>
            <span class="tab-badge"
              *ngIf="getTemplateCount('WELCOME_TEMPLATE') > 0">{{getTemplateCount('WELCOME_TEMPLATE')}}</span>
          </div>
        </ng-template>

        <div class="tab-content">
          <div class="content-header">
            <h2>Welcome Templates</h2>
            <p>Create and manage welcome templates for candidate onboarding</p>
          </div>

          <div class="templates-container">
            <div class="templates-header">
              <button mat-stroked-button color="primary" class="create-btn" (click)="addWelcomeTemplate()">
                <mat-icon>add</mat-icon>
                Create Welcome Template
              </button>
            </div>

            <div class="templates-content">
              <div class="templates-grid" *ngIf="welcomeTemplates?.length > 0">
                <div class="template-card"
                  *ngFor="let item of welcomeTemplates; let i = index; trackBy: trackByTemplateId">
                  <div class="template-header">
                    <div class="template-info">
                      <h4 [innerHTML]="item?.templateName | replaceAll : headerPlaceholderDummies"></h4>
                      <span class="template-type">Welcome Template</span>
                    </div>
                    <div class="template-actions">
                      <button class="action-btn expand-btn" mat-icon-button (click)="expandWelcomeTemplate(i)">
                        <mat-icon>{{selectedWelcomeTemplateIndex === i ? 'expand_less' : 'expand_more'}}</mat-icon>
                      </button>
                      <ng-container *ngIf="!item.isDefault">
                        <button class="action-btn edit-btn" mat-icon-button
                          (click)="editTemplate(item, 'Welcome Template')">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button class="action-btn delete-btn" mat-icon-button
                          (click)="deleteTemplate(item, 'welcome template')">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                  <div class="template-preview" *ngIf="selectedWelcomeTemplateIndex === i">
                    <app-template-details [index]="i" [templateDetails]="item" [templateType]="'welcome'"
                      [cardHeading]="welcomeCardHeading" [assessmentData]="null"
                      [companyName]="companyDetailsForm.get('companyName')?.value"
                      [mobileNumber]="companyDetailsForm.get('phone')?.value?.number"
                      [profile]="companyDetailsForm?.value">
                    </app-template-details>
                  </div>
                </div>
              </div>

              <div class="empty-state" *ngIf="welcomeTemplates?.length == 0">
                <div class="empty-icon">
                  <mat-icon>waving_hand</mat-icon>
                </div>
                <h3>No Welcome Templates yet</h3>
                <p>Get started by creating your first welcome template for candidates.</p>
                <button mat-stroked-button color="primary" (click)="addWelcomeTemplate()">
                  <mat-icon>add</mat-icon>
                  Create Welcome Template
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- WhatsApp Templates Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label">
            <mat-icon class="tab-icon">chat</mat-icon>
            <span>WhatsApp Templates</span>
            <span class="tab-badge"
              *ngIf="getTemplateCount('WHATSAPP_TEMPLATE') > 0">{{getTemplateCount('WHATSAPP_TEMPLATE')}}</span>
          </div>
        </ng-template>

        <div class="tab-content">
          <div class="content-header">
            <h2>WhatsApp Templates</h2>
            <p>Predefined templates for WhatsApp communications</p>
          </div>

          <div class="templates-container">
            <div class="templates-content">
              <div class="templates-grid" *ngIf="whatsAppTemplates?.length > 0">
                <div class="template-card"
                  *ngFor="let item of whatsAppTemplates; let i = index; trackBy: trackByTemplateId">
                  <div class="template-header">
                    <div class="template-info">
                      <h4>{{item?.templateName}}</h4>
                      <span class="template-type">WhatsApp Template</span>
                    </div>
                    <div class="template-actions">
                      <button class="action-btn expand-btn" mat-icon-button (click)="expandWhatsAppTemplate(i)">
                        <mat-icon>{{selectedWhatsAppTemplateIndex === i ? 'expand_less' : 'expand_more'}}</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="template-preview" *ngIf="selectedWhatsAppTemplateIndex === i">
                    <app-template-details [templateDetails]="item" [templateType]="'whatsapp'" [logo]="logo"
                      [mobileNumber]="companyDetailsForm.get('phone')?.value?.number"
                      [cardHeading]="whatsAppCardHeading" [assessmentData]="null"
                      [companyName]="companyDetailsForm.get('companyName')?.value"
                      [profile]="companyDetailsForm?.value">
                    </app-template-details>
                  </div>
                </div>
              </div>

              <div class="empty-state" *ngIf="whatsAppTemplates?.length == 0">
                <div class="empty-icon">
                  <mat-icon>chat</mat-icon>
                </div>
                <h3>No WhatsApp Templates found</h3>
                <p>Predefined templates will appear here when available.</p>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </mat-card>
</div>